module.exports = __webpack_public_path__ + "img/ceb310858ba0dc29aceaeb6f18d59d82.png";